module.exports = __webpack_public_path__ + "img/custom.089d1673.png";